export function ajaxHandler(method, url, jsonParams, token) {
    return new Promise((resolve, reject) => {
        const client = new XMLHttpRequest();
        const uri = url;

        let jsonAsString = '';
        client.open(method, uri);
        if (method === 'POST' || method === 'PUT') {
            if (jsonParams) {
                jsonAsString = JSON.stringify(jsonParams) || '';
            }
        }

        client.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        if (token) {
            client.setRequestHeader('Authorization', `Bearer ${token}`);
        }

        client.send(jsonAsString);

        client.onload = function onload() {
            if (this.status >= 200 && this.status < 300) {
                let responseToken = '';

                if (this.getResponseHeader('X-VF-Access-Token')) {
                    responseToken = this.getResponseHeader('X-VF-Access-Token');
                }

                resolve({data: this.response, token: responseToken, status: this.status});
            } else {
                reject(this.statusText);
            }
        };

        client.onerror = function onerror() {
            reject(this.statusText);
        };
    });
}
